import { render, staticRenderFns } from "./SiteReportRouterWrapper.vue?vue&type=template&id=54e4ded1&scoped=true&"
import script from "./SiteReportRouterWrapper.vue?vue&type=script&lang=js&"
export * from "./SiteReportRouterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SiteReportRouterWrapper.vue?vue&type=style&index=0&id=54e4ded1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4ded1",
  null
  
)

export default component.exports